import { FC } from 'react';
import { Row } from 'antd';

import notebookIcon from 'images/icons/notebook.svg';
import styles from './noCustomPageSection.module.less';

type NoPlansViewProps = {
  title?: string;
  subheader?: string;
};

const NoCustomPageSections: FC<NoPlansViewProps> = ({
  title = '',
  subheader = '',
}: NoPlansViewProps) => {
  return (
    <div
      className={`${styles.errorBoundaryWrapper} ${styles.noLeftMargin}
      `}
    >
      <Row className={styles.detailsWrapper}>
        <img src={notebookIcon} alt="edit" />
      </Row>
      <Row className={styles.header}>{title}</Row>
      <Row className={styles.subHeader}>
        <span className={styles.firstLine}>{subheader}</span>
      </Row>
    </div>
  );
};

export default NoCustomPageSections;
